import React from 'react';
import xss from 'xss';
import TitleHeader from '../../components/molecules/TitleHeader/TitleHeader';
import { signCopy } from '../../content/main.json';
import './Sign.scss';

const {
  title,
  category,
  information,
} = signCopy;

const Sign = () => (
  <div className="sign">
    <TitleHeader title={title} category={category} large />
    <div className="sign__content">
      {information.map((line) => (
        <p
          key={line}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: xss(line) }}
        />
      ))}
    </div>
  </div>
);

export default Sign;
